<template>
    <div class="col-8 col-md-10">
        <div class="row">
            <div class="col-12 col-lg-5 field-label align-self-top">
                {{ label }}
            </div>

            <div class="col-12 col-lg-7 field-value align-self-top" :class="{ error: hasError }">
                {{ value }}
            </div>
        </div>
    </div>

    <div class="col-4 col-md-2 edit">
        <a @click="edit()">{{ $t('form.summary.labels.edit') }}</a>
    </div>
</template>

<script>
export default {
    emits: ["edit"],
    props: {
        label: null,
        value: null,
        hasError: null
    },
    methods: {
        edit() {
            this.$emit("edit")
        },
    },
}
</script>

<style lang="scss" scoped>
@import '~scss/settings/responsive';
@import '~scss/settings/variables';
@import '~scss/mixins/rem';

.error {
    color: #ff0000;
}

.field-label {
    font-size: rem(13px);

    @media screen and (min-width: $bp-large) {
        font-size: rem(15px);
    }
}

.field-value {
    font-size: rem(15px);
    font-weight: 700;
}

.edit {
    font-size: rem(15px);
    font-weight: 700;
    text-align: right;

    a {
        color: var(--wizard-button-color);
        cursor: pointer;
    }
}
</style>
